// 日期相关的常量

import { TimeRangePickerProps } from 'antd';
import dayjs from 'dayjs';

// 时间格式
export const TIME_FORMAT = {
  day: 'YYYY-MM-DD',
  hour: 'YYYY-MM-DD HH',
  min: 'YYYY-MM-DD HH:mm',
  sec: 'YYYY-MM-DD HH:mm:ss',
  small_hour: 'HH',
  small_min: 'HH:mm',
  small_sec: 'HH:mm:ss',
};

// 日期范围占位符
export const DATE_RANGE_PLACEHOLDER = ['开始时间', '结束时间'];

// 日期快捷筛选
export const DATE_RANGE_PRESETS: TimeRangePickerProps['presets'] = [
  { label: '本月至今', value: [dayjs().startOf('month'), dayjs()] },
  { label: '本周至今', value: [dayjs().startOf('week'), dayjs()] },
  { label: '昨天', value: [dayjs().subtract(1, 'day'), dayjs().subtract(1, 'day')] },
  { label: '本周', value: [dayjs().startOf('week'), dayjs()] },
  { label: '上周', value: [dayjs().subtract(7, 'day'), dayjs().subtract(1, 'day')] },
  { label: '本月', value: [dayjs().startOf('month'), dayjs()] },
  {
    label: '上个月',
    value: [
      dayjs().subtract(1, 'month').startOf('month'),
      dayjs().subtract(1, 'month').endOf('month'),
    ],
  },
];
